import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PlaceholderPage.module.css';

const PlaceholderPage = ({ title = 'Page', description = 'This page is under construction' }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{description}</p>
        <button className={styles.backButton} onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    </div>
  );
};

export default PlaceholderPage;

